import { createAction } from '@reduxjs/toolkit';

export const emailsRequest = createAction('emails/request');
export const emailsError = createAction('emails/error');
export const emailsStore = createAction('emails/store');
export const emailsSendStore = createAction('emails/sendStore');
export const emailsHydrateFromTemplate = createAction('emails/hydrateFromTemplate');

export const emailsUpdateTitle = createAction('emails/updateTitle');
export const emailsUpdateSubject = createAction('emails/updateSubject');

export const emailsUpdateBackgourndColor = createAction('emails/updateBackgourndColor');
export const emailsUpdateBackdropColor = createAction('emails/updateBackdropColor');
export const emailsUpdateTextColor = createAction('emails/updateTextColor');
export const emailsUpdateFont = createAction('emails/updateFont');

export const emailsUpdateReplyToAddress = createAction('emails/updateReplyToAddress');
export const emailsUpdateSenderName = createAction('emails/updateSenderName');

export const emailsUpdateBlocks = createAction('emails/updateBlocks');
